import * as LicenseActions from './license.actions';

export default LicenseActions;
